module.exports = __webpack_public_path__ + "static/img/016.af636576.png";